export enum CalendarView {
    dayGridMonth,
    dayGridWeek,
    timeGridWeek,
    timeGridDay,
    listWeek
}
